import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-black border-t border-primary-500/20 py-8">
      <div className="container-max">
        <div className="text-center">
          <p className="text-gray-400 text-sm">
            {t.footer.copyright}
          </p>
          <p className="text-gray-500 text-sm mt-4">
            {t.footer.madeBy}{' '}
            <a
              href="https://alldevs.cz"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-400 hover:text-primary-300 transition-colors"
            >
              AllDevs
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
